export const DISPERSE_ADDRESS = "XAPTQfpsddWDJ9kkkVBQjkchzHjpD9Bz4noneJmfBvTySC7";
export const RPC_URL = "wss://rpc.shibuya.astar.network";
export const DISPERSE_ADDRESS_NETWORK = ["XAPTQfpsddWDJ9kkkVBQjkchzHjpD9Bz4noneJmfBvTySC7",
"YCgRauicmg5jjZioTojmD8KAKEzf9Jsz1DfZ1WZsdurQ1eG","5FS7LycuEgvur4mVag5RqZ48NKNrKazPZxZK11Pt5JmxjQ3F"];
export const RPC_URL_NETWORK = ["wss://rpc.shibuya.astar.network","wss://rpc.shiden.astar.network","wss://rococo-contracts-rpc.polkadot.io"];
export const NAME_NETWORK = ["SHIBUYA","SHIDEN","ROCOCO"];
export const DISPERSE_ADDRESS_SHIBUYA = "XAPTQfpsddWDJ9kkkVBQjkchzHjpD9Bz4noneJmfBvTySC7";
export const DISPERSE_ADDRESS_SHIDEN = "YCgRauicmg5jjZioTojmD8KAKEzf9Jsz1DfZ1WZsdurQ1eG";
export const DISPERSE_ADDRESS_ROCOCO = "5FS7LycuEgvur4mVag5RqZ48NKNrKazPZxZK11Pt5JmxjQ3F";
export const RPC_URL_SHIDEN = "https://rpc.shiden.astar.network";
export const RPC_URL_SHIBUYA = "wss://rpc.shibuya.astar.network";
export const RPC_URL_ROCOCO = "wss://rococo-contracts-rpc.polkadot.io";
//export const RPC_URL_LOCAL = "ws://127.0.0.1:9944";